import { IconClose } from "../../../components/Icons";

type Props = {
  onChoose: (type: "immediate" | "request") => void;
  onClose: () => void;
};

export default function ChooseCancellationTypeModal({
  onChoose,
  onClose,
}: Props) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15, 23, 42, 0.55)",
        zIndex: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "min(460px, 92vw)",
          background: "white",
          borderRadius: "0.55rem",
          boxShadow: "0 10px 32px rgba(0,0,0,.2)",
          // Reset inheritance from any table-cell ancestor (the chooser is
          // mounted inside StatusChangeButton, which lives in a <td> that
          // forces white-space: nowrap + textAlign on its descendants).
          whiteSpace: "normal",
          textAlign: "left",
          overflow: "hidden",
        }}
      >
        <header
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0.85rem 1rem",
            borderBottom: "1px solid #e9ecef",
            gap: "0.75rem",
          }}
        >
          <h3 style={{ margin: 0, fontSize: ".95rem", color: "#1f2933", flex: 1 }}>
            ¿Qué tipo de cancelación?
          </h3>
          <button type="button" onClick={onClose} style={closeBtn}>
            <IconClose />
          </button>
        </header>

        <div style={{ padding: "1rem", display: "grid", gap: "0.6rem" }}>
          <ChoiceCard
            title="Cancelación inmediata"
            description="Para impagos y leads incomplete. Cancela ahora y dispara el email automático con el motivo elegido."
            onClick={() => onChoose("immediate")}
          />
          <ChoiceCard
            title="Solicitud del cliente (Tipo 1)"
            description="El cliente firma una solicitud vía Viafirma. La póliza se queda activa hasta confirmar la fecha efectiva del carrier."
            onClick={() => onChoose("request")}
            tone="primary"
          />

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "0.4rem",
            }}
          >
            <button type="button" onClick={onClose} style={ghostBtn}>
              Volver
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ChoiceCard({
  title,
  description,
  onClick,
  tone = "neutral",
}: {
  title: string;
  description: string;
  onClick: () => void;
  tone?: "primary" | "neutral";
}) {
  const isPrimary = tone === "primary";
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        textAlign: "left",
        padding: "0.75rem 0.9rem",
        borderRadius: "0.5rem",
        border: `1px solid ${isPrimary ? "#0069d9" : "#dee2e6"}`,
        background: isPrimary ? "#f0f7ff" : "#f8f9fb",
        cursor: "pointer",
        display: "block",
        width: "100%",
      }}
    >
      <div
        style={{
          fontSize: ".88rem",
          fontWeight: 700,
          color: isPrimary ? "#0069d9" : "#1f2933",
          marginBottom: "0.25rem",
        }}
      >
        {title}
      </div>
      <div style={{ fontSize: ".78rem", color: "#73879C", lineHeight: 1.4 }}>
        {description}
      </div>
    </button>
  );
}

const closeBtn: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "1.85rem",
  height: "1.85rem",
  padding: 0,
  borderRadius: "0.4rem",
  background: "#f8f9fb",
  color: "#1f2933",
  border: "1px solid #dee2e6",
  cursor: "pointer",
};

const ghostBtn: React.CSSProperties = {
  padding: "0.45rem 0.95rem",
  borderRadius: "0.4rem",
  background: "white",
  color: "#73879C",
  border: "1px solid #dee2e6",
  fontSize: ".82rem",
  fontWeight: 600,
  cursor: "pointer",
};
